module.exports = __webpack_public_path__ + "assets/img/mountains.6ad9cdc3.png";